import { api } from "../lib/client.js";
import { useAsync } from "../lib/useAsync.js";
import { formatDateTime } from "../lib/format.js";
import { Failed, Loading } from "../components/ViewState.js";
import { DataList, DataRow, PageSection } from "../components/Page.js";

// No empty state: getSettings always resolves every key to a default, so this
// view cannot render with nothing. A view over genuinely emptyable data owes
// the fourth state (docs/REQUIREMENTS.md section 4).
export function SitePage() {
  const { state, reload } = useAsync(
    api.site,
    "Could not load site details. The server may be unreachable.",
  );

  return (
    <PageSection title="Site">
      {state.kind === "loading" && <Loading label="Loading site details…" />}
      {state.kind === "error" && <Failed message={state.message} onRetry={reload} />}
      {state.kind === "ready" && (
        <DataList>
          <DataRow label="Site name">{state.value.siteName}</DataRow>
          <DataRow label="Timezone">{state.value.timezone}</DataRow>
          <DataRow label="Currency">{state.value.currency}</DataRow>
          <DataRow label="Last changed">{formatDateTime(state.value.updatedAt)}</DataRow>
        </DataList>
      )}
    </PageSection>
  );
}
